module.exports = __webpack_public_path__ + "img/report2.6988245d.png";